import React, { useState } from 'react';
import styled from 'styled-components';
import StarRatings from 'react-star-ratings';

const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '1800px',
};
export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};

const ReviewContainer = styled.div`
  display: flex;
  gap: 80px;
  max-width: 782px;
  justify-content: space-between;
  justify-self: center;
  margin-top: 60px;
  @media only screen and ${device.tablet} {
    gap: 10px;
    width: 345px;
    margin-top: 60px;
    display: none;
  }
`;

const ReviewBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`;

const ReviewText = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  color: #151515;
  max-width: 206px;
  text-align: center;
  @media only screen and ${device.tablet} {
    font-size: 12px;
  }
`;
const ReviewComponent = () => {
  return (
    <ReviewContainer>
      <ReviewBox>
        <StarRatings
          rating={5}
          starRatedColor='#FBBC05'
          starEmptyColor='#1D1D1D33'
          numberOfStars={5}
          name='rating'
          starDimension='18px'
          starSpacing='2px'
        />
        <ReviewText>
          “I cracked my life’s best campaign using this tool”
        </ReviewText>
      </ReviewBox>
      <ReviewBox>
        <StarRatings
          rating={3.5}
          starRatedColor='#FBBC05'
          numberOfStars={5}
          name='rating'
          starEmptyColor='#1D1D1D33'
          starDimension='18px'
          starSpacing='2px'
        />
        <ReviewText>“Your AI reads my customers better than I do” </ReviewText>
      </ReviewBox>
      <ReviewBox>
        <StarRatings
          rating={5}
          starRatedColor='#FBBC05'
          numberOfStars={5}
          name='rating'
          starEmptyColor='#1D1D1D33'
          starDimension='18px'
          starSpacing='2px'
        />
        <ReviewText>
          “I can’t believe they are offering so much in such cost!”{' '}
        </ReviewText>
      </ReviewBox>
    </ReviewContainer>
  );
};

export default ReviewComponent;
